import './global.js'
import Parse from 'parse';
import React from 'react';
import { Route, Link} from "react-router-dom";
import Leftsidebar from "./Leftsidebar.jsx";

class Messages extends React.Component {
    render() {    
        return (
            <section className='post_list'> 
                <div className='container'>
                    <div className='inner'>
                        <nav className='sidebar'>
                            <Leftsidebar/>
                        </nav>
                        <main className='listing explr-list no_message'>
                            Direct Messages coming soon.
                        </main>
                    </div>
                </div>
            </section>      
        );
    }
}

export default Messages;


// WEBPACK FOOTER //
// ./src/Messages.jsx